/*
================================================================================
File: src/components/common/Character.js
Description: Renders the floating AI assistant character icon.
================================================================================
*/
import React from 'react';

const Character = ({ isFloating = false }) => {
  const floatingStyle = isFloating
    ? { animation: "float 4s ease-in-out infinite" }
    : {};

  return (
    <svg
      width="100"
      height="100"
      className="w-full h-full"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={floatingStyle}
    >
      <g
        fill="#4285f4"
        fillRule="evenodd"
        transform="translate(4.453125 2.0625)"
      >
        <path d="m3.31971582 2.33823529.00009594 3.99472004.00412508-.00014296-.00412508.00253919v5.24097294l3.08759008 1.7885983-3.40772939 2.0206654-2.30735058-1.3399851c-.40888134-.237377-.65992003-.6706733-.65992003-1.138824v-7.90373382c0-.4681779.25103869-.90140617.65992003-1.13885121z" />
        <path d="m11.673009 7.66941176 3.3593928 2.00914567v3.25339057c0 .4699828-.2497809.9048433-.6567403 1.1431829l-6.84418751 4.00893-.0203207-.011958.01479729.011958-2.95218791 1.7444301c-.15820139.0934773-.36258803.0416138-.45650647-.1158215-.03043331-.0510435-.04654667-.1092618-.04666941-.1686417l-.00693495-3.4293438 3.53280746-2.1127359-.01043311-.0174245 4.08705101-2.3880428z" />
        <path d="m8.21240328.18320117 6.20611302 3.6124228c.4094506.23829354.6607605.67306994.6607605 1.14292769v3.33880128l-3.4764194-2.0660692-.0037049.00596417-4.11097184-2.38693884-3.04952882 1.77072322v-4.01303263l2.41387871-1.40479849c.41960454-.24426823.94019958-.24426823 1.35987273 0z" />
      </g>
    </svg>
  );
};

export default Character;
